export default class PaymentRent {
    constructor() {
        this.id = "";
        this.typePayment = { id: "", content: "" };
        this.dueDate = "";
        this.value = 0;
        this.description = "";
        this.payableReceivable = {};
        this.status = 0;
        this.registerInFinance = false;
    }
    update(data) {
        this.id = data.id;
        this.typePayment = { id: data.typePaymentId, content: data.typePaymentName };
        this.dueDate = data.dueDate;
        this.value = data.value;
        this.description = data.description;
        this.payableReceivable = data.payableReceivable;
    }
}